/**
 * API Configuration
 * Centralized configuration for backend API URL
 */

// Backend API Base URL
//export const API_BASE_URL = 'http://localhost:5001/api/v1';           // Local backend url
//export const API_BASE_URL = 'https://quiz.fkpartners.com/api/v1' ; // production backend url
//export const API_BASE_URL = 'http://18.231.13.119/api/v1' ; //staging backend url
export const API_BASE_URL = 'https://quiz.fkpartners.com/api/v1' ; // Production  backend url
// Environment

export const APP_ENV = 'development';


// Export as default config object
const config = {
  
  
  apiUrl: API_BASE_URL,
  environment: APP_ENV,
  
};



export default config;
